import { useMigrateUserToNonEidOrganizationMutation } from "@/graphql/types";
import gql from "graphql-tag";

gql`
  mutation migrateUserToNonEidOrganization($userId: ID!) {
    migrateUserToNonEidOrganization(userId: $userId) {
      userId
    }
  }
`;

export default function (userId: string) {
  const migrateUserToNonEidOrganizationMutation =
    useMigrateUserToNonEidOrganizationMutation({});

  async function call() {
    return migrateUserToNonEidOrganizationMutation.mutate({ userId: userId });
  }

  return {
    ...migrateUserToNonEidOrganizationMutation,
    call,
  };
}
